import { useState } from 'react';
import { CostLabel } from './Amount';
const { Modal, Form } = require('react-bootstrap');

// A dialog for choosing the target of an action (e.g. which building to destroy) from a dropdown; ConfirmLabel: its
// button's text, when not the title. Buttons: each option a button of its own instead, picked with one click (the
// action bar's choices)
function ActionPrompt({Title, Options, OnConfirm, OnCancel, ConfirmLabel, Buttons = false})
{
    const [selected, setSelected] = useState(0);

    if (Buttons)
    {
        return (
            <Modal show onHide={OnCancel} centered size="sm">
                <Modal.Header closeButton style={{ padding: '8px 12px' }}>
                    <Modal.Title style={{ fontSize: '16px', fontWeight: 'bold' }}>{Title}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="tta tta-prompt-options" style={{ padding: '12px' }}>
                    {Options.map((option, index) =>
                        <button key={index} className="tta-button tta-prompt-option" autoFocus={index === 0} onClick={() => OnConfirm(option)}>
                            <span>{option.label}</span>
                            {option.cost && <span className="tta-prompt-cost"><CostLabel cost={option.cost}/></span>}
                            {option.costNote && <span className="tta-prompt-note">{option.costNote}</span>}
                        </button>)}
                </Modal.Body>
                <Modal.Footer className="tta" style={{ padding: '6px 12px' }}>
                    <button className="tta-button" onClick={OnCancel}>Cancel</button>
                </Modal.Footer>
            </Modal>
        );
    }

    return (
        <Modal show onHide={OnCancel} centered size="sm">
            <Modal.Header closeButton style={{ padding: '8px 12px' }}>
                <Modal.Title style={{ fontSize: '16px', fontWeight: 'bold' }}>{Title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="tta tta-left" style={{ padding: '12px' }}>
                <Form.Select size="sm" value={selected} onChange={(e) => setSelected(Number(e.target.value))} autoFocus>
                    {Options.map((option, index) =>
                        <option key={index} value={index}>
                            {option.label}{option.cost ? ` · ${option.cost}` : ''}{option.costNote ? ` (${option.costNote})` : ''}
                        </option>)}
                </Form.Select>
            </Modal.Body>
            <Modal.Footer className="tta" style={{ padding: '6px 12px' }}>
                <button className="tta-button" onClick={OnCancel}>Cancel</button>
                <button className="tta-button dark" onClick={() => OnConfirm(Options[selected])}>{ConfirmLabel ?? Title}</button>
            </Modal.Footer>
        </Modal>
    );
}

export default ActionPrompt;